import type { ColDef, GridOptions, ITextFilterParams } from "ag-grid-community"

export const commonTextFilterParams: ITextFilterParams = {
  filterOptions: ["contains"],
  maxNumConditions: 1,
  buttons: ["clear", "apply"],
  closeOnApply: true,
}

export const commonDefaultColDef: ColDef = {
  sortable: true,
  resizable: true,
  filter: "agTextColumnFilter",
  filterParams: commonTextFilterParams,
}

export const commonGridOptions = {
  enableFilterHandlers: true,
} satisfies GridOptions
